import { axios } from 'lib/axios';

export const registerWithEmailAndPassword = data => {
  console.log('register values', data);
  return axios.post('/auth/register/', data);
};
